/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_FileInputs */

const en_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose file`)
};

const es_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir archivo`)
};

const fr_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un fichier`)
};

const de_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei auswählen`)
};

const ja_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルを選択`)
};

const zh_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择文件`)
};

const ar_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر ملفاً`)
};

const id_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih file`)
};

const it_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli file`)
};

const ru_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать файл`)
};

const pt_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher arquivo`)
};

const ko_choose_file = /** @type {(inputs: Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 선택`)
};

/**
* | output |
* | --- |
* | "Choose file" |
*
* @param {Choose_FileInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const choose_file = /** @type {((inputs?: Choose_FileInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_FileInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_choose_file(inputs)
	if (locale === "es") return es_choose_file(inputs)
	if (locale === "fr") return fr_choose_file(inputs)
	if (locale === "de") return de_choose_file(inputs)
	if (locale === "ja") return ja_choose_file(inputs)
	if (locale === "zh") return zh_choose_file(inputs)
	if (locale === "ar") return ar_choose_file(inputs)
	if (locale === "id") return id_choose_file(inputs)
	if (locale === "it") return it_choose_file(inputs)
	if (locale === "ru") return ru_choose_file(inputs)
	if (locale === "pt") return pt_choose_file(inputs)
	return ko_choose_file(inputs)
});